import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import isLoggedIn from '../../../utils/auth';
import {formatCarat, formatShape, formatPrice, formatCut, formatColor, formatClarity, formatSymmetry, formatPolish, formatLocation, getLocationId, formatMeasurements} from '../../../utils/formatting';

import * as diamondsActionCreators from '../../../actions/diamonds';
let allActionCreators = Object.assign({}, diamondsActionCreators);

class VideoPlayer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loadingVideo: true,
      framesLoaded: 0,
      frameCount: 1,
      loadedImages: 0,
      minLoaded: 0,
      maxSpeed: 10, // target seconds / rotation
      currentSpeed: 0,
      currentFrame: 1,
      rotationId: null,
      draggableScroll: false,
      draggableScrollWidth: 0,
      draggableScrollStartPos: 0,
      lastTouch: 0,
      videoLoaded: false,
    }

    this.props.fetchDiamondManifest(this.props.diamondObj.gia_number)
    .then((respData) => {
        
      this.setState({ 
        frameCount: respData.count,
        framesLoaded: 0,
      });
    });

    // Bind event listeners
    this.rotationCounter = this.rotationCounter.bind(this);
    this.startRotation = this.startRotation.bind(this);
    this.rotateVideo = this.rotateVideo.bind(this);

    this.checkMove = this.checkMove.bind(this);
  }

  componentWillMount() {
    // window.addEventListener('mouseup', this.startRotation, false);
    window.addEventListener('touchend touchcancel', this.startRotation, false);
    // window.addEventListener('mousemove', this.rotateVideo, false);
    window.addEventListener('touchmove', this.rotateVideo, false);
  }

  componentDidMount() {
    let checkId = setInterval(this.checkMove, 100);
  }

  componentWillUnmount() {
    // window.removeEventListener('mouseup', this.startRotation, false);
    window.removeEventListener('touchend touchcancel', this.startRotation, false);
    // window.removeEventListener('mousemove', this.rotateVideo, false);
    window.removeEventListener('touchmove', this.rotateVideo, false);
    clearInterval(this.state.rotationId);
  }

  checkMove() {
    if(this.state.draggableScroll) {
      if(this.state.lastTouch && this.state.lastTouch + 2000 < Date.now()) {
        this.startRotation(null);
      }
    }
  }

  rotateVideo(evt) {
    if(this.state.draggableScroll && this.state.videoLoaded) {
      let currentPosX = evt.screenX;
        if(!currentPosX) {
        // is touch
        currentPosX = evt.touches[0].screenX;
      }

      let relativePosX = this.state.draggableScrollStartPos - currentPosX;

      let decimalRelativePosX = (relativePosX / this.state.draggableScrollWidth) % 1;

      let frameOffset = Math.floor(decimalRelativePosX * this.state.frameCount);
      let newFrame = this.state.draggableScrollStartFrame + frameOffset;

      if(newFrame < 1) {
        newFrame = newFrame + this.state.frameCount;
      } else if(newFrame > this.state.frameCount) {
        newFrame = newFrame - this.state.frameCount;
      }

      this.setState({
        currentFrame: newFrame,
        lastTouch: Date.now(),
      })
    }
  }

  userNav(page) {
    history.push('/' + page);
  }

  numericalArray() {
    let numArray = [];
    for(let i = 1; i <= this.state.frameCount; i ++) {
      numArray.push(i);
    }
    return numArray;
  }

  formatImgName(key) {
    if(key < 10) {
      return '000' + key + '.jpg';
    } else if(key < 100) {
      return '00' + key + '.jpg';
    } else if(key < 1000) {
      return '0' + key + '.jpg';
    } else {
      return key + '.jpg';
    }
  }

  imageLoaded(imgNum) {
    if(this.state.frameCount > 1) {
      this.setState({
        loadedImages: this.state.loadedImages + 1,
      }, () => {
        let loadingTarget = 0.50;
        let fullyLoadedTarget = 1.00;
        let targetFrame = Math.floor(loadingTarget * this.state.frameCount);
        let fullTargetFrame = Math.floor(fullyLoadedTarget * this.state.frameCount);

        if(this.state.loadedImages == targetFrame) {
          this.startRotation(null);
        }
        if(this.state.loadedImages == fullTargetFrame) {
          this.setState({ videoLoaded: true });
        }
      })
    }
  }

  dragStart(cursorPosX) {
    let diamondWidth = 0;

    if(this.videoHolder) {
      this.setState({
        draggableScroll: true,
        draggableScrollWidth: this.videoHolder.offsetWidth,
        draggableScrollStartPos: cursorPosX,
        draggableScrollStartFrame: this.state.currentFrame,
      });
    }
  }

  dragStop() {
    this.setState({
      draggableScroll: false,
      draggableScrollWidth: 0,
      draggableScrollStartPos: 0,
      draggableScrollStartFrame: 1,
    });
  }

  startRotation(evt) {

    if(evt) { evt.preventDefault(); }

    this.setState({ lastTouch: 0 });

    if(this.state.currentSpeed == 0) {
      let rotationRate = (this.state.maxSpeed * 1000) / this.state.frameCount;
      let rotationId = setInterval(this.rotationCounter, rotationRate);
      this.setState({ 
        rotationId: rotationId,
        currentSpeed: this.state.maxSpeed,
        draggableScroll: false,
      }, () => {
        this.dragStop();
      });
    }
  }

  stopRotation(evt) {
    let cursorPosX = evt.screenX;

    if(!cursorPosX) {
      // is touch
      cursorPosX = evt.touches[0].screenX;
    }

    // evt.preventDefault();
    clearInterval(this.state.rotationId);
    this.setState({ 
      currentSpeed: 0,
      draggableScroll: true,
    }, () => {
      this.dragStart(cursorPosX);
    });
  }

  rotationCounter() {
    if(this.state) {
      let newFrame = this.state.currentFrame + 1;
      if(newFrame > this.state.frameCount) {
        newFrame = 2;
      }
      this.setState({ currentFrame: newFrame });
    }
  }

  render() {

    let imgNum = this.numericalArray();

    return <div className={this.props.isZoomed ? 'VideoPlayer zoomed' : 'VideoPlayer'}>
      <div className='videoHolder'
           onTouchStart={this.stopRotation.bind(this)}
           ref={(div) => { this.videoHolder = div; }}>
        {this.state.frameCount == 1 ?
          <img src={'https://s3.amazonaws.com/inv-app-diamond-assets-processed-prod/' + this.props.diamondObj.gia_number + '/0001.jpg'} /> :
          <div>
            {imgNum.map((loaded, i) => {
              return (
                <img 
                  key={i}
                  draggable='false'
                  src={'https://s3.amazonaws.com/inv-app-diamond-assets-processed-prod/' + this.props.diamondObj.gia_number + '/' + this.formatImgName(i + 1)}
                  onLoad={() => this.imageLoaded(loaded)}
                  style={{display: this.state.currentFrame == loaded ? 'block' : 'none'}} />
              );
            })}
          </div>
        }
      </div>
      <div className='videoLabel'>360&deg; video</div>
    </div>;
  }
}
export default VideoPlayer;

function mapStateToProps(state) {
  return {
    diamonds: state.diamonds,
  };
}

export const VideoPlayerContainer = connect(
  mapStateToProps,
  allActionCreators
)(VideoPlayer);